/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagDiscoveryResourceMapping {
    getFixupPrototypeFunction() { return TagDiscoveryResourceMapping.fixupPrototype; }

    static newInstance(model: Partial<TagDiscoveryResourceMapping>): TagDiscoveryResourceMapping {
        let obj = Object.assign(new TagDiscoveryResourceMapping(), model);
        TagDiscoveryResourceMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagDiscoveryResourceMapping>): TagDiscoveryResourceMapping {
        if (!model) return null;
        return TagDiscoveryResourceMapping.newInstance(<TagDiscoveryResourceMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagDiscoveryResourceMapping) {
        if (!obj) return;

        models.TagDiscoveryResourceMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagDiscoveryResourceMapping): boolean {
        Object.setPrototypeOf(obj, TagDiscoveryResourceMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ResourceArn
     */
    arn: string;

    /**
     * Service Resource Inventory Unique Id
     */
    inventory_id: string;

}
